// This file was generated by "make codegen/iam". DO NOT EDIT.

import { GET_ASSIGNED_POLICIES as ACTION_MONDOO_POLICY_EXTENDEDHUB_GETASSIGNEDPOLICIES } from "~/lib/iam/actions/mondoo/policy/ExtendedHub/GetAssignedPolicies/action";
import { GET_BUNDLE as ACTION_CNSPEC_POLICY_POLICYHUB_GETBUNDLE } from "~/lib/iam/actions/cnspec/policy/PolicyHub/GetBundle/action";
import { GET_POLICY as ACTION_CNSPEC_POLICY_POLICYHUB_GETPOLICY } from "~/lib/iam/actions/cnspec/policy/PolicyHub/GetPolicy/action";
import { GET_RESOURCE_WORKSPACES as ACTION_MONDOO_POLICY_EXTENDEDHUB_GETRESOURCEWORKSPACES } from "~/lib/iam/actions/mondoo/policy/ExtendedHub/GetResourceWorkspaces/action";
import { GET_SPACE as ACTION_MONDOO_CAPTAIN_CAPTAIN_GETSPACE } from "~/lib/iam/actions/mondoo/captain/Captain/GetSpace/action";
import { GET_SPACE_SCAN_SETTINGS as ACTION_MONDOO_POLICY_EXTENDEDHUB_GETSPACESCANSETTINGS } from "~/lib/iam/actions/mondoo/policy/ExtendedHub/GetSpaceScanSettings/action";
import { LIST_RISK_FACTORS as ACTION_MONDOO_POLICY_EXTENDEDHUB_LISTRISKFACTORS } from "~/lib/iam/actions/mondoo/policy/ExtendedHub/ListRiskFactors/action";
import { LIST_USER_WORKSPACES as ACTION_MONDOO_POLICY_EXTENDEDHUB_LISTUSERWORKSPACES } from "~/lib/iam/actions/mondoo/policy/ExtendedHub/ListUserWorkspaces/action";

export const allowedActions = [
  ACTION_CNSPEC_POLICY_POLICYHUB_GETBUNDLE,
  ACTION_CNSPEC_POLICY_POLICYHUB_GETPOLICY,
  ACTION_MONDOO_CAPTAIN_CAPTAIN_GETSPACE,
  ACTION_MONDOO_POLICY_EXTENDEDHUB_GETASSIGNEDPOLICIES,
  ACTION_MONDOO_POLICY_EXTENDEDHUB_GETRESOURCEWORKSPACES,
  ACTION_MONDOO_POLICY_EXTENDEDHUB_GETSPACESCANSETTINGS,
  ACTION_MONDOO_POLICY_EXTENDEDHUB_LISTRISKFACTORS,
  ACTION_MONDOO_POLICY_EXTENDEDHUB_LISTUSERWORKSPACES,
] as const;
